<template>
    <div class="af" v-loading="loading">
        <div class="flex w100 marT10">
            <div class="flex w33 alc">
                <span class="marr4 font14">{{$t('invoiceEntry_billing_type')}}</span>
                <el-select style="width: 220px" @change="changeData($event,'fpt')" @clear="clearsearch('fpt')" class="marr4" v-model="vc_type" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_billing_type')">
                    <el-option
                            v-for="item in fpType"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w33 alc">
                <span class="marr4 font14">{{$t('invoiceEntry_issuer')}}</span>
                <el-select style="width: 220px" @change="changeData($event,'kpf')" @clear="clearsearch('kpf')" class="marr4" v-model="vc_kpkhname" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_invoicing_party')">
                    <el-option
                            v-for="item in kpfData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
            <div class="flex w33 alc">
                <span class="marr4 font14">{{$t('invoiceEntry_purchaser')}}</span>
                <el-select style="width: 220px" @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable filterable :placeholder="$t('invoiceEntry_please_select_the_ticketing_company')">
                    <el-option
                            v-for="item in compsData"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="flex w100 marT10">
            <div class="flex w33 alc">
                <span class="marr4 font14">{{$t('invoiceEntry_time')}}</span>
                <el-date-picker
                        style="width: 220px"
                        class="marr4"
                        size="mini"
                        v-model="valuetime"
                        @change="getTimes"
                        :clearable="false"
                        type="daterange"
                        :range-separator="$t('form_to')"
                        :start-placeholder="$t('form_start_date')"
                        :end-placeholder="$t('form_end_date')">
                </el-date-picker>
            </div>
            <div class="flex w66 alc">
                <el-input @blur="gosearch" @clear="clearsearch('sou')" prefix-icon="el-icon-search" class="marr4" style=""  v-model="vc_search" :placeholder="$t('invoiceEntry_please_search_by_invoice_number')" clearable size="mini"></el-input>
            </div>

        </div>
        <el-table
                ref="table"
                size="mini"
                border
                :data="tableData"
                height="275"
                style="width: 100%"
                class="marT10"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow"
                @row-click="clickrow">
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_fpcode"
                    :label="$t('invoiceEntry_invoice_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_fppzname"
                    :label="$t('form_variety')"
                    show-overflow-tooltip>
                <template>
                    <template slot-scope="scope">
                        <span>{{scope.row.detailCount>1?(scope.row.vc_fppzname+$t('invoiceEntry_etc')+scope.row.detailCount+'个'):scope.row.vc_fppzname}}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_pay"
                    :label="$t('invoiceEntry_invoice_amount')"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <span class="fl" style="margin-left:4px;height:21px;line-height: 50px;font-size: 10px;color: #fa5050;text-decoration: underline" @click="openfresh">{{$t('invoiceEntry_cannot_find_data_click_here')}}</span>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {
        },
        props:{
           /* addData:{
                type:Object,
                required:true,
            }*/
        },
        data(){
            return{
                loading:false,
                baseerp:"",
                mid:0,
                vc_fkey:"",
                form:[],
                compsData:[],
                companyName:'',
                companyId:0,
                vc_gscreditcode:"",
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                vc_khcreditcode:"",
                fpType:[],
                i_type:0,
                i_khtype:0,
                i_origin_khtype:0,
                vc_fymx:'',
                i_issd:0,
                i_flag:0,
                vc_type:"",
                tableData:[],
                highlightCurrentRow:false,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                vc_search:'',
                isdk:0,
            }
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.fptype();
            this.getCompanyList();
            this.getfMou();
        },
        methods:{
            openfresh() {
                this.$confirm(this.$t('invoiceEntry_will_the_latest_data_be_pulled_from_the_invoice_pool_if_not_please_contact_finance_are_you_sure_you_want_to_retrieve_the_data_again'), this.$t('tips_prompt'), {
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type: 'warning'
                }).then(() => {
                    this.refresh();
                }).catch(() => {

                });
            },
            async refresh(){
                this.loading=true;
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.refresh(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            gosearch(){
                this.currentPage=1;
                this.tableData=[];
                this.beforehandle();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.beforehandle();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.beforehandle();
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
            },
            clickrow(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.vc_fkey=row.vc_fkey;
                this.form=row;
                //this.application.i_pid=row.i_pid;
                //console.log(this.application,"this.application")

            },
            //根据开票方获取发票编号列表
            async beforehandle(){
                let param = {
                    'i_mid':this.mid,
                    'vc_kpkhname':this.vc_kpkhname,
                    'vc_khcreditcode':this.vc_khcreditcode,
                    'vc_gsname':this.companyName,
                    'vc_gscreditcode':this.vc_gscreditcode,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_search':this.vc_search,
                    'invoiceType':1,
                };
                let res = await API.beforehandle(param);
                if (res.code == 1) {
                    this.tableData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取交易公司
            async getCompanyList(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //查询开票类型
            async fptype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.i_type = res.data.list[0].i_id;
                    this.vc_type = res.data.list[0].vc_name;
                    this.i_khtype = res.data.list[0].i_khtype;
                    this.i_origin_khtype = res.data.list[0].i_origin_khtype;
                    this.vc_fymx= res.data.list[0].vc_fymx;
                    //this.i_isagent = res.data.list[0].i_isagent;
                    this.isdk = res.data.list[0].i_dkable;
                    this.i_issd=res.data.list[0].i_issd;
                    this.i_flag=res.data.list[0].i_flag;
                    this.f_sl = res.data.list[0].f_sl;
                    this.getkhlist();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            yanzheng(){
                if(this.i_type==0){
                    this.$message.warning(this.$t('invoiceEntry_please_select_the_billing_type')+'!');
                    return;
                }
                if(this.i_kpkhid==0){
                    this.$message.warning(this.$t('invoiceEntry_please_select_the_invoicing_party'));
                    return;
                }
                if(this.companyId==0){
                    this.$message.warning(this.$t('invoiceEntry_please_select_the_buyer'));
                    return;
                }
                this.beforehandle()
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.i_origin_khtype = choo[0].i_origin_khtype;
                        this.vc_fymx = choo[0].vc_fymx;
                        //this.i_isagent=choo[0].i_isagent;
                        this.isdk=choo[0].i_dkable;
                        this.i_issd=choo[0].i_issd;
                        this.i_flag=choo[0].i_flag;
                        this.f_sl=choo[0].f_sl;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        this.getkhlist();
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.i_origin_khtype=0;
                        this.vc_fymx = '';
                        //this.i_isagent=0;
                        this.isdk=0;
                        this.i_issd=0;
                        this.i_flag=0;
                        this.f_sl=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }
                }
                if(type=='state'){
                    this.isover=e;
                    let choo = this.stateData.filter(item=>{
                        return item.isover == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_isover=choo[0].vc_name;
                    }else{
                        this.vc_isover='';
                    }
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('invoiceEntry_please_select_the_invoice_type_first'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                            this.vc_khcreditcode=choo[0].vc_creditcode;
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }else{
                            this.vc_kpkhname='';
                            this.vc_khcreditcode='';
                            this.xsData=[];
                            this.xsComname='';
                            this.xsComId=0;
                        }
                    }
                    /*if(this.i_kpkhid!=0&&this.companyId!=0&&this.isdk==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        this.beforehandle();
                    }*/
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                        this.vc_gscreditcode=choo[0].vc_creditcode;
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }else{
                        this.companyName='';
                        this.vc_gscreditcode='';
                        this.xsData=[];
                        this.xsComname='';
                        this.xsComId=0;
                    }
                    /*if(this.i_kpkhid!=0&&this.companyId!=0&&this.isdk==1){
                        this.getKhByKz();
                    }
                    if(this.i_kpkhid!=0&&this.companyId!=0&&this.i_isfrom==1){
                        this.beforehandle();
                    }*/
                }
                if(type=='xs'){
                    this.xsComId=e;
                    let choo = this.xsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.xsComname=choo[0].vc_name;
                        this.vc_khcreditcode=choo[0].vc_creditcode;
                    }else{
                        this.xsComname='';
                        this.vc_khcreditcode='';
                    }
                }
                if(type=='fplx'){
                    this.i_fptype=e;
                    let choo = this.fplxData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_fptype=choo[0].vc_name;
                    }else{
                        this.vc_fptype='';
                    }
                }
                if(type=='code'){
                    this.vc_fkey = e;
                    if(this.vc_fkey!=0){
                        this.beforedetail()
                    }
                }
                this.yanzheng()
            },
            clearsearch(type){
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_origin_khtype=0;
                    this.vc_fymx = '';
                    this.i_issd=0;
                    this.i_flag=0;
                    this.f_sl=0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.isover=null;
                    this.vc_isover='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.vc_khcreditcode='';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                    this.vc_gscreditcode='';
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                if(type=='xs'){
                    this.xsComId=0;
                    this.xsComname='';
                    this.vc_khcreditcode='';
                }
                if(type=='fplx'){
                    this.i_fptype=0;
                    this.vc_fptype='';

                }
                if(type=='code'){
                    this.vc_fkey = 0;
                }
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            //保存
            async saveForm(){
                if(this.vc_fkey){
                    let map={
                        vc_fkey:this.vc_fkey,
                        vc_type:this.vc_type,
                        i_khtype:this.i_khtype,
                        i_origin_khtype:this.i_origin_khtype,
                        vc_fymx:this.vc_fymx ,
                        //i_isagent:this.i_isagent,
                        i_dkable:this.isdk,
                        i_type:this.i_type,
                        i_issd:this.i_issd,
                        i_flag:this.i_flag,
                        f_sl:this.f_sl,
                        i_kpkhid:this.i_kpkhid,
                        vc_kpkhname:this.vc_kpkhname,
                        vc_khcreditcode:this.vc_khcreditcode,
                        companyId:this.companyId,
                        companyName:this.companyName,
                        vc_gscreditcode:this.vc_gscreditcode,
                        form:this.form,
                    }
                    this.$emit('cancelDialog_fpc',map)
                }else{
                    this.$message.error(this.$t('invoiceEntry_please_select_the_invoice_number_to_be_entered'));
                }

            },
            cancel(){
                this.$emit('cancelDialog_fpc');
            },

        }
    }
</script>

<style  lang="scss" scoped>
    .w66{
        width: 66%;
    }

    /deep/.el-table td{
        text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w25{
        width: 25%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .fl{
        float: left;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
